export default __webpack_public_path__ + "static/media/noData.6eab02e4.png";